// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0a281e9d","644":"406120c1","732":"dfafab80"}[chunkId] + ".chunk.js";
};